import { createFileRoute } from '@tanstack/react-router';
import { creatorPortalHomeQuery } from '@/services/creator-portal';
import { CreatorPortalHome } from '@/features/creator-portal/portal-home';

/**
 * The creator's home: every deal they have through Dreamwell. The loader starts the read and never waits for it, so a
 * slow first load shows the page's own loading card, never the app's Draper splash; a refusal is the page's to show.
 */
export const Route = createFileRoute('/creator/$token/')({
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.prefetchQuery(creatorPortalHomeQuery(params.token));
  },
  component: CreatorPortalHomeRoute,
});

function CreatorPortalHomeRoute() {
  const { token } = Route.useParams();
  return <CreatorPortalHome token={token} />;
}
